import React, { useState, useEffect, memo } from 'react';
import { PivotViewComponent, PivotColumn, IDataOptions, QueryCellInfoEventArgs, ConditionalFormatting, IDataSet, CalculatedField, PDFExport, pdfQueryCellInfo, FieldList, Inject, Toolbar, ToolbarArgs, RemoveReportArgs, LoadReportArgs, RenameReportArgs, SaveReportArgs, FetchReportArgs, ColumnRenderEventArgs } from '@syncfusion/ej2-react-pivotview';
import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import { getValue } from '@syncfusion/ej2-base';
import './style.css';
import { image } from './image';
import { imageDigital } from './imageDigital';
import { PdfHeaderQueryCellInfoEventArgs, PdfQueryCellInfoEventArgs, Column, Aggregate } from '@syncfusion/ej2-react-grids';
import { NotificacaoInterna } from '../../../../Services/Notification';
import { useHistory } from "react-router-dom";
import { Moeda } from '../../../../Themes/TextFormat'
import apiAdonis from '../../../../Services/adonis';
import { api } from '../../Services/api';
import moment from 'moment';
import { Button, FormGroup, Icon, MenuItem, Checkbox, Collapse, Divider } from '@blueprintjs/core';
import { PdfPaddings } from '@syncfusion/ej2-pdf-export';

function App({ dados, saldoInicial, dataInicial, dataFinal, visualizacao, getItemPickerEmpreendimento }: any) {
  const History = useHistory();
  async function VerifyToken() {

    await apiAdonis.post('/verify', {}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(async result => {
      if (result.data.check) {
        return null
      }
      else {
        NotificacaoInterna.ExibirNotificacao("Acesso Expirado!", "Seu acesso à aplicação foi expirado!", NotificacaoInterna.TipoDeNotificacao.Informacao);
        History.replace("/");
        window.location.reload();
      }
    });
  }

  const [getData, setData] = useState(dados);
  const [getSaldoInicial, setSaldoInicial] = useState<string | undefined>();
  const [getCollapse, setCollapse] = useState<boolean>(false);
  const [getExpandAll, setExpandAll] = useState<boolean>(false);
  let pivotObj: PivotViewComponent;

  let dataSourceSettings: IDataOptions = visualizacao === "validacao" ? {
    enableSorting: true,
    columns: [{ name: 'Ano' }, { name: 'MesAno' }],
    valueSortSettings: { headerDelimiter: ' - ' },
    drilledMembers: [{ name: "Ano", items: ["2021", "2022", "2023"] }],
    values: [{ name: 'ValorRec', caption: 'Valor Recebido' } /*, { name: 'Amount', caption: 'Sold Amount' }*/],
    dataSource: getData,
    rows: [{ name: 'TIPO'/*'Natureza'*/, caption: 'TIPO'/*'Natureza'*/ }],
    formatSettings: [{ name: 'ValorRec', format: 'C2' }, { name: 'MesAno', type: 'date', format: "MM/yyyy" }, { name: 'Data Compensacao', type: 'date', format: "dd/MM/yyyy" }],
    expandAll: false,
    filters: [{ name: 'MesAno', caption: 'mesano' }],
    conditionalFormatSettings: [
    ],
    showGrandTotals: false
  } : visualizacao === "fluxo de caixa" ? {
    enableSorting: true,
    columns: [{ name: 'Ano' }, { name: 'MesAno' }],
    valueSortSettings: { headerDelimiter: ' - ' },
    drilledMembers: [{ name: "Ano", items: ["2021", "2022", "2023"] }],
    values: [{ name: 'ValorRec', caption: 'Valor Recebido' } /*, { name: 'Amount', caption: 'Sold Amount' }*/],
    dataSource: getData,
    rows: [{ name: 'fluxo_tipo'/*'Natureza'*/, caption: 'fluxo_tipo'/*'Natureza'*/ }, { name: 'grupo'/*'Natureza'*/, caption: 'grupo'/*'Natureza'*/ }, { name: 'SERVICO', caption: 'SERVIÇO' }, { name: 'categoria', caption: 'categoria' }, { name: 'NM_CLIENTE', caption: 'NM_CLIENTE' }],
    formatSettings: [{ name: 'ValorRec', format: 'C2' }, { name: 'MesAno', type: 'date', format: "MM/yyyy" }, { name: 'Data Compensacao', type: 'date', format: "dd/MM/yyyy" }],
    expandAll: false,
    filters: [{ name: 'MesAno', caption: 'mesano' }],
    conditionalFormatSettings: [
    ],
    showGrandTotals: false
  } : {
    enableSorting: true,
    columns: [{ name: 'Ano' }, { name: 'MesAno' }],
    valueSortSettings: { headerDelimiter: ' - ' },
    drilledMembers: [{ name: "Ano", items: ["2021", "2022", "2023"] }],
    values: [{ name: 'ValorRec', caption: 'Valor Recebido' } /*, { name: 'Amount', caption: 'Sold Amount' }*/],
    dataSource: getData,
    rows: [{ name: 'NM_Obra'/*'Natureza'*/, caption: 'NM_Obra'/*'Natureza'*/ }, { name: 'fluxo_tipo'/*'Natureza'*/, caption: 'fluxo_tipo'/*'Natureza'*/ }, { name: 'grupo'/*'Natureza'*/, caption: 'grupo'/*'Natureza'*/ }, { name: 'SERVICO', caption: 'SERVIÇO' }, { name: 'categoria', caption: 'categoria' }, { name: 'NM_CLIENTE', caption: 'NM_CLIENTE' }],
    formatSettings: [{ name: 'ValorRec', format: 'C2' }, { name: 'MesAno', type: 'date', format: "MM/yyyy" }, { name: 'Data Compensacao', type: 'date', format: "dd/MM/yyyy" }],
    expandAll: false,
    filters: [{ name: 'MesAno', caption: 'mesano' }],
    conditionalFormatSettings: [
    ],
    showGrandTotals: false
  }

  useEffect(() => {
    async function componentDidMount() {
      await VerifyToken();
      if (dados !== undefined && saldoInicial) {
        const groups = dados.groups;

        let data = JSON.parse(JSON.stringify(dados.response).replace(/GRUPO/g, /*'Natureza'*/'GRUPO').replace(/KEY_CDEMP_CDOBR_BD/g, 'Nome obra'));

        if (visualizacao === "fluxo de caixa") {
          console.log("data")
          console.log(data)
          let total_op = 0;
          let total_dist = 0;
          let total_xop = 0;
          data.forEach((row: any) => {
            if (row.dimensao === "1 - RECEBIMENTOS (+)" || row.dimensao === "2 - SAIDAS (-)") {
              total_op += row.ValorRec ?? 0;
            } else if (row.dimensao === "4 - DISTRIBUICAO DE LUCROS (+/-)") {
              total_dist += row.ValorRec ?? 0;
            } else if (row.dimensao === "6 - MOV. EXTRA OPERACIONAL (+/-)") {
              total_xop += row.ValorRec ?? 0;
            }
          });
          saldoInicial.forEach((saldo: any) => {
            data.push(
              {
                "KEY_CDEMP_BD": data[0].KEY_CDEMP_BD ?? "",
                "KEY_CDEMP_CDOBR_BD": data[0].KEY_CDEMP_CDOBR_BD ?? "",
                "NumParc_des": null,
                "PRODUTO": null,
                "NM_CLIENTE": null,
                "Data Compensacao": saldo.dateChoosed + "T03:00:00.000Z",
                "ValorRec": saldo.total_saldo,
                "MesAno": moment(saldo.dateChoosed, "YYYY-MM-DD").startOf('month').format("YYYY-MM-DD") + "T03:00:00.000Z" ?? "",
                "Ano": Number(moment(saldo.dateChoosed, "YYYY-MM-DD").format("YYYY")) ?? "",
                "GRUPO": null,
                "TIPO": null,
                "cap": null,
                "categoria": null,
                "Divisao": "Empresa",
                "NM_Obra": null,
                "SERVICO": null,
                "grupo": null,
                "fluxo_tipo": "0 - SALDO INICIAL",
                "dimensao": null,
                "Num_proc": null
              }
            )
          })
          groups.forEach((group: any) => {
            data.push(
              {
                "KEY_CDEMP_BD": data[0].KEY_CDEMP_BD ?? "",
                "KEY_CDEMP_CDOBR_BD": data[0].KEY_CDEMP_CDOBR_BD ?? "",
                "NumParc_des": null,
                "PRODUTO": null,
                "NM_CLIENTE": null,
                "Data Compensacao": group.MesAno,
                "ValorRec": group.resultado_operacional,
                "MesAno": group.MesAno,
                "Ano": Number(moment(group.MesAno, "YYYY-MM-DD").format("YYYY")),
                "GRUPO": null,
                "TIPO": null,
                "cap": null,
                "categoria": null,
                "Divisao": "Empresa",
                "NM_Obra": null,
                "SERVICO": null,
                "grupo": null,
                "fluxo_tipo": "3 - RESULTADO OPERACIONAL (=)",
                "dimensao": null,
                "Num_proc": null
              }
            )
            data.push(
              {
                "KEY_CDEMP_BD": data[0].KEY_CDEMP_BD ?? "",
                "KEY_CDEMP_CDOBR_BD": data[0].KEY_CDEMP_CDOBR_BD ?? "",
                "NumParc_des": null,
                "PRODUTO": null,
                "NM_CLIENTE": null,
                "Data Compensacao": group.MesAno,
                "ValorRec": group.resultado_liquido,
                "MesAno": group.MesAno,
                "Ano": Number(moment(group.MesAno, "YYYY-MM-DD").format("YYYY")),
                "GRUPO": null,
                "TIPO": null,
                "cap": null,
                "categoria": null,
                "Divisao": "Empresa",
                "NM_Obra": null,
                "SERVICO": null,
                "grupo": null,
                "fluxo_tipo": "5 - RESULTADO LÍQUIDO (=)",
                "dimensao": null,
                "Num_proc": null
              }
            )
            data.push(
              {
                "KEY_CDEMP_BD": data[0].KEY_CDEMP_BD ?? "",
                "KEY_CDEMP_CDOBR_BD": data[0].KEY_CDEMP_CDOBR_BD ?? "",
                "NumParc_des": null,
                "PRODUTO": null,
                "NM_CLIENTE": null,
                "Data Compensacao": group.MesAno,
                "ValorRec": (saldoInicial.find((sal: any) => sal.dateChoosed + "T03:00:00.000Z" === group.MesAno).total_saldo) + (group.resultado_liquido) + (group.resultado_extra),
                "MesAno": group.MesAno,
                "Ano": Number(moment(group.MesAno, "YYYY-MM-DD").format("YYYY")),
                "GRUPO": null,
                "TIPO": null,
                "cap": null,
                "categoria": null,
                "Divisao": "Empresa",
                "NM_Obra": null,
                "SERVICO": null,
                "grupo": null,
                "fluxo_tipo": "7 - RESULTADO FINAL (=)",
                "dimensao": null,
                "Num_proc": null
              }
            )
          })
          setSaldoInicial(Moeda.FormatarTexto(saldoInicial[0].total_saldo));

          console.log(data)
        }

        await setData(data);
      }
    }
    componentDidMount();
  }, [dados, saldoInicial, visualizacao])
  const saveReport = (args: any) => {
    let reports: SaveReportArgs[] = [];
    let isSaved: boolean = false;
    if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
      reports = JSON.parse(localStorage.pivotviewReports);
    }
    if (args.report && args.reportName && args.reportName !== '') {
      reports.map(function (item: any): any {
        if (args.reportName === item.reportName) {
          item.report = args.report; isSaved = true;
        }
      });
      if (!isSaved) {
        reports.push(args);
      }
      localStorage.pivotviewReports = JSON.stringify(reports);
      console.log('saveReport: ' + localStorage.pivotviewReports);
    }
  }
  const beforeToolbarRender = (args: ToolbarArgs | any) => {
    args.customToolbar.splice(6, 0, {
      type: 'Separator'
    });
    args.customToolbar.splice(9, 0, {
      type: 'Separator'
    });
  }
  const fetchReport = (args: FetchReportArgs | any) => {
    let reportCollection: string[] = [];
    let reeportList: string[] = [];
    if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
      reportCollection = JSON.parse(localStorage.pivotviewReports);
      console.log('reportCollection(fetchReport): ' + reportCollection)
    }
    reportCollection.map(function (item: any): void { reeportList.push(item.reportName); });
    args.reportName = reeportList;
  }
  const loadReport = (args: LoadReportArgs | any) => {
    let reportCollection: string[] = [];
    if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
      reportCollection = JSON.parse(localStorage.pivotviewReports);
      console.log('reportCollection(loadReport): ' + reportCollection)
    }
    reportCollection.map(function (item: any): void {
      if (args.reportName === item.reportName) {
        args.report = item.report;
        console.log('args.report(loadReport): ' + args.report)
      }
    })
    if (args.report) {
      pivotObj.dataSourceSettings = JSON.parse(args.report).dataSourceSettings;
      console.log('pivotObj.dataSourceSettings(loadReport): ' + dataSourceSettings)
    }
  }
  const removeReport = (args: RemoveReportArgs | any) => {
    let reportCollection: any[] = [];
    if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
      reportCollection = JSON.parse(localStorage.pivotviewReports);
      console.log('reportCollection(removeReport): ' + reportCollection)
    }
    for (let i: number = 0; i < reportCollection.length; i++) {
      if (reportCollection[i].reportName === args.reportName) {
        reportCollection.splice(i, 1);
        console.log('reportCollection(removeReport): ' + reportCollection)
      }
    }
    if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
      localStorage.pivotviewReports = JSON.stringify(reportCollection);
      console.log('localStorage.pivotviewReports(removeReport): ' + localStorage.pivotviewReports)
    }
  }
  const renameReport = (args: RenameReportArgs | any) => {
    let reportsCollection: any[] = [];
    if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
      reportsCollection = JSON.parse(localStorage.pivotviewReports);
      console.log('reportsCollection(removeReport): ' + reportsCollection)
    }
    if (args.isReportExists) {
      for (let i: number = 0; i < reportsCollection.length; i++) {
        if (reportsCollection[i].reportName === args.rename) {
          reportsCollection.splice(i, 1);
          console.log('reportsCollection(removeReport): ' + reportsCollection)
        }
      }
    }
    reportsCollection.map(function (item: any): any { if (args.reportName === item.reportName) { item.reportName = args.rename; } });
    if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
      localStorage.pivotviewReports = JSON.stringify(reportsCollection);
      console.log('reportsCollection(removeReport): ' + reportsCollection)
    }
  }
  const newReport = () => {
    pivotObj.setProperties({ dataSourceSettings: { columns: [], rows: [], values: [], filters: [] } }, false);
  }
  const pdfQueryCellInfo = (args: PdfQueryCellInfoEventArgs) => {
    if (args.column?.headerText.includes("Total") && (args.data as any)[0]?.actualText.includes('SALDO')) {
      console.log((args.data as any));
      // (args.data as any)[(args.data as any)?.length - 1].actualValue = 0;
      args.value = getSaldoInicial;
    }


    if ((args.data as any)[0].level === 0 && visualizacao === "fluxo por obra") {
      args.style = { backgroundColor: '#fff1d0', textBrushColor: "#000000", bold: true, fontSize: 10, fontFamily: "sans-serif", /*cellPadding: pdf*/ };
      (args.cell as any).cellHeight = 12;
    }
    else if ((args.data as any)[0].actualText.includes("ENTRADAS") || (args.data as any)[0].actualText.includes("SAIDAS") || (args.data as any)[0].actualText.includes("LUCROS (+/-)")) {
      args.style = { backgroundColor: '#225166', textBrushColor: "#FFFFFF", bold: true, fontSize: 9, fontFamily: "sans-serif", /*cellPadding: pdf*/ };
      (args.cell as any).cellHeight = 12;
    }
    else if ((args.data as any)[0].actualText.includes("(=)")) {
      // const level = (args.data as any)[0].level + 1;
      // let pdf = new PdfPaddings();
      // pdf.left = 10 * level;

      args.style = { backgroundColor: '#14394a', textBrushColor: "#FFFFFF", bold: true, fontSize: 9, fontFamily: "sans-serif", /*cellPadding: pdf*/ };
      (args.cell as any).cellHeight = 12;
      console.log(args.style)
    } else if ((args.data as any)[0].actualText.includes("SALDO INICIAL")) {
      // const level = (args.data as any)[0].level + 1;
      // let pdf = new PdfPaddings();
      // pdf.left = 10 * level;

      args.style = { backgroundColor: '#fff1d0', textBrushColor: "#000000", bold: true, fontSize: 9, fontFamily: "sans-serif", /*cellPadding: pdf*/ };
      (args.cell as any).cellHeight = 12;
    } else if ((args.data as any)[0].actualText.includes("(+)") || (args.data as any)[0].actualText.includes("(-)") || (args.data as any)[0].actualText.includes("OPERACIONAL (+/-)")) {
      // const level = (args.data as any)[0].level + 1;
      // let pdf = new PdfPaddings();
      // pdf.left = 10 * level;

      args.style = { backgroundColor: '#eeeeee', textBrushColor: "#000000", bold: true, fontSize: 9, fontFamily: "sans-serif", /*cellPadding: pdf*/ };
      (args.cell as any).cellHeight = 12;
    }
    else {
      const level = (args.data as any)[0].level;
      // let pdf = new PdfPaddings();
      // pdf.left = 10 * level;

      args.style = { backgroundColor: level >= 2 ? '#ffffff' : '#f5f5f5', textBrushColor: "#000000", bold: level >= 2 ? false : true, fontSize: 9, fontFamily: "sans-serif", /*cellPadding: pdf*/ }
    }
  }
  const pdfHeaderQueryCellInfo = (args: PdfHeaderQueryCellInfoEventArgs | any) => {
    (args.cell as any).row.pdfGrid.repeatHeader = true;
    args.cell.gridRow.pdfGrid.columns.getColumn(0).width = 200;
    args.cell.gridRow.pdfGrid.columns.getColumn(1).textAlign = "Right";
  }
  function btnClick() {
    pivotObj.pdfExport({
      pageOrientation: "Portrait",
      exportType: 'AllPages',
      theme: {
        header: { fontSize: 5, bold: true },
        record: { fontSize: 5 },
        caption: { bold: false }
      },
      header: {
        fromTop: 0,
        height: 100,
        contents: [
          {
            position: { x: 0, y: 0 },
            size: { height: 70, width: 100 },
            src: image,
            type: 'Image',
          },
          {
            type: 'Text',
            value: `${getData[0].NM_Empresa}`,
            position: { x: 120, y: 0 },
            style: { textBrushColor: '#000000', fontSize: 13 }
          },
          {
            type: 'Text',
            value: `${getItemPickerEmpreendimento?.NM_Obra ?? " "}`,
            position: { x: 120, y: 40 },
            style: { textBrushColor: '#000000', fontSize: 13 }
          },
          {
            type: 'Text',
            value: `De ${moment(dataInicial).format('DD/MM/YYYY')} até ${moment(dataFinal).format('DD/MM/YYYY')}`,
            position: { x: 120, y: 15 },
            style: { textBrushColor: '#000000', fontSize: 13 }
          }
        ]
      },
      footer: {
        fromBottom: 0,
        height: 50,
        contents: [
          {
            type: 'PageNumber',
            pageNumberType: 'Arabic',
            format: 'Page {$current} of {$total}',
            position: { x: 0, y: 25 },
            style: { textBrushColor: '#000000', fontSize: 15 }
          },
          {
            type: 'Text',
            value: "Powered By",
            position: { x: 230, y: 30 },
            style: { textBrushColor: '#000000', fontSize: 13, dashStyle: 'Solid', hAlign: 'Center' }
          },
          {
            position: { x: 300, y: 30 },
            style: { hAlign: 'Center' },
            size: { height: 15, width: 70 },
            src: imageDigital,
            type: 'Image',
          }
        ]
      },
      allowHorizontalOverflow: false
    });
  }
  function btnClickExcel() {
    pivotObj.excelExport()
  }
  function queryCellInfo(args: QueryCellInfoEventArgs) {
    if (args.column?.headerText.includes("Total") && (args.data as any)[0]?.actualText.includes('SALDO')) {
      console.log((args.data as any));
      // (args.data as any)[(args.data as any)?.length - 1].actualValue = 0;
      (args.cell as any).innerHTML = getSaldoInicial;
      (args.cell as any).innerText = getSaldoInicial;
    }

    if ((args.data as any)[0]?.actualText.includes('ENTRADAS') && visualizacao !== "validacao") {
      (args.cell as HTMLElement).style.backgroundColor = '#052330d8';
      (args.cell as HTMLElement).style.color = '#ffffff';
      (args.cell as HTMLElement).style.fontWeight = 'bold';
    } else if ((args.data as any)[0]?.actualText.includes('SAIDAS') && visualizacao !== "validacao") {
      (args.cell as HTMLElement).style.backgroundColor = '#052330d8';
      (args.cell as HTMLElement).style.color = '#ffffff';
      (args.cell as HTMLElement).style.fontWeight = 'bold';
    } else if ((args.data as any)[0]?.actualText.includes('(=)') && visualizacao !== "validacao") {
      (args.cell as HTMLElement).style.backgroundColor = 'rgb(5 35 48)';
      (args.cell as HTMLElement).style.color = '#ffffff';
      (args.cell as HTMLElement).style.fontWeight = 'bold';
    } else if ((args.data as any)[0]?.actualText.includes('DISTRIBUICAO DE LUCROS (+/-)') && visualizacao !== "validacao") {
      (args.cell as HTMLElement).style.backgroundColor = '#052330d8';
      (args.cell as HTMLElement).style.color = '#ffffff';
      (args.cell as HTMLElement).style.fontWeight = 'bold';
    } else if ((args.data as any)[0]?.actualText.includes('SALDO INICIAL') && visualizacao !== "validacao") {
      (args.cell as HTMLElement).style.backgroundColor = '#fff1d0';
      (args.cell as HTMLElement).style.fontWeight = 'bold';
      (args.cell as HTMLElement).style.color = '#000000';
    }
  }

  return (
    <>
      <div className='control-pane' style={{ width: "100%" }}>
        <div style={{ height: getCollapse ? "70px" : "unset" }}>
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "left" }}>
            <div className="col-lg-3 property-section">
              <ButtonComponent
                cssClass="e-primary"
                style={{ border: "none", boxShadow: "unset", width: "202px", marginRight: "20px" }}
                onClick={() => { btnClick() }}
              >
                PDF
              </ButtonComponent>
              {/* <button onClick={() => console.log(dataSourceSettings)}>Button</button> */}
            </div>
            <div className="col-lg-3 property-section">
              <ButtonComponent
                cssClass="e-primary"
                style={{ border: "none", boxShadow: "unset", width: "202px" }}
                onClick={() => { btnClickExcel() }}
              >
                EXCEL
              </ButtonComponent>
              {/* <button onClick={() => console.log(dataSourceSettings)}>Button</button> */}
            </div>
          </div>
        </div>
        <div className='control-section' style={{ overflow: 'auto', width: "100%" }}>
          <PivotViewComponent
            ref={(d) => (d != null ? pivotObj = d : null)}
            id='PivotView'
            beforeColumnsRender={(args: ColumnRenderEventArgs) => {
              args.columns[0].width = 350;
            }}
            dataSourceSettings={dataSourceSettings}
            showToolbar={true}
            showTooltip={true}
            gridSettings={{ columnWidth: 140, allowTextWrap: false, clipMode: "EllipsisWithTooltip" }}
            allowConditionalFormatting={true}
            allowExcelExport={true}
            allowPdfExport={true}
            toolbar={["FieldList"/*,'New', 'Save', 'SaveAs', 'Rename', 'Remove', 'Load'*/]}
            toolbarRender={beforeToolbarRender}
            pdfHeaderQueryCellInfo={pdfHeaderQueryCellInfo}
            pdfQueryCellInfo={pdfQueryCellInfo}
            queryCellInfo={queryCellInfo}
            height={800}
            locale='pt-BR'
            style={{ maxWidth: "100%", overflow: "auto" }}
            allowCalculatedField={true}
            showFieldList={true}
            newReport={newReport}
            renameReport={renameReport}
            removeReport={removeReport}
            loadReport={loadReport}
            fetchReport={fetchReport}
            saveReport={saveReport}
          >
            <Inject services={[FieldList, CalculatedField, Toolbar, ConditionalFormatting]} />
          </PivotViewComponent>
        </div>
        {/* Buttons */}
        {false && <div style={{ display: "flex" }}>
          <div className="col-lg-3 property-section">
            <ButtonComponent
              cssClass="e-primary"
              style={{ border: "none", boxShadow: "unset", width: "202px", height: "30px", borderRadius: "unset", marginRight: "20px" }}
              onClick={() => setExpandAll(!getExpandAll)}
            >
              EXPANDIR/RECOLHER
            </ButtonComponent>
            {/* <button onClick={() => console.log(dataSourceSettings)}>Button</button> */}
          </div>
        </div>}
      </div>
    </>
  );
}

export default memo(App);